import templateUrl from './process-tax-notice-pending.component.html';

export const ProcessTaxNoticePendingComponent = {
    templateUrl,
    controller: ProcessTaxNoticePendingController,
    controllerAs: "vm",
};

function ProcessTaxNoticePendingController(taxNoticeService, employeeService, utilityService, taxNoticeUpdateService){
    'ngInject';
    const vm = this;
    vm.documents = [];
    vm.documentsbk = [];
    vm.toggle = toggle;
    vm.allComments = [];
    vm.isComment = false;
    vm.comment = comment;
    vm.saveComment = saveComment;

    vm.download = download;
    vm.cancel = cancel;

    vm.complete = complete;
    vm.decline = decline;

    vm.onSelectCommentFile = onSelectCommentFile;
    vm.noticeCommentFiles;
    vm.commentFileName;
    vm.downloadNoticeCommentDoc = downloadNoticeCommentDoc;
    vm.isStatusHistory = false;
    vm.statusHistory = statusHistory;
    vm.allStatuses = [];
    vm.userName;
    vm.close = close;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.editID = '';
    vm.editDesc = '';
    vm.setEditNotice = setEditNotice;
    vm.clearEditNotice = clearEditNotice;

    vm.$onInit = function () {
        utilityService.showLoading();
        taxNoticeUpdateService.processTaxNoticeRefreshEvents$.forEach(event => {
            if (event === "update") {
                refreshData();
            }
        });
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.retrievePendingDocuments(result.UserName)
                    .then(function (mydocs) {
                        vm.documents = mydocs;
                        vm.documentsbk = mydocs;
                        return result;
                    })
            })
            .catch((err) => {
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            })

        utilityService.hideLoading();
    };


    function setEditNotice(noticeDocumentId: string, description: string) {
        vm.editID = noticeDocumentId;
        vm.editDesc = description;
    }

    function clearEditNotice() {
        vm.editID = '';
        vm.editDesc = '';
    }

    function close() {
        vm.isUpload = false;
        vm.showAssign = false;
        vm.isStatusHistory = false;
        vm.isComment = false;
    }

    function refreshData() {
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.retrievePendingDocuments(vm.userName)
                    .then(function (mydocs) {
                        vm.documents = mydocs;
                        vm.documentsbk = mydocs;
                    });
            })
            .catch((err) => {
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function toggle(document: any, description: string) {
        if (document.Description !== description) {
            utilityService.showLoading();
            taxNoticeService.updateDescription({
                TaxNoticeDocumentId: document.NoticeDocumentId,
                Text: description
            }).then(function (result) {
                vm.editID = '';
                vm.editDesc = '';
                const edited = vm.documents.find(x => x.NoticeDocumentId === document.NoticeDocumentId);
                edited.Description = description;
                vm.documents.splice(vm.documents.indexOf(document), 1, edited);
                utilityService.hideLoading();
            }).catch(function (ex) {
                utilityService.hideLoading();
            });
        } else {
            vm.editID = '';
            vm.editDesc = '';
        }
    }

    function statusHistory(requestId: any) {
        utilityService.showLoading();
        vm.isStatusHistory = true;
        vm.requestId = requestId;

        taxNoticeService.retrieveStatusHistory(vm.requestId)
            .then(function (result) {
                vm.allStatuses[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("StatusHistory: " + utilityService.getExceptionMessage(err));
            })
    }

    function onSelectCommentFile() {
        vm.commentFileName = vm.noticeCommentFiles.name;
    }

    function downloadNoticeCommentDoc(commentId: any) {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((identity) => {
                taxNoticeService.downloadNoticeCommentDocument({
                    CommentId: commentId,
                    TaxNoticeDocumentId: 'N/A',
                    UserName: identity.UserName,
                    Text: 'downloading comment file',
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember'
                })
                    .then(function (isDownloaded) {
                        utilityService.hideLoading();
                        return isDownloaded;
                    })
                    .catch(function (ex) {
                        utilityService.hideLoading();
                        console.error(ex);
                        alert("Downloading failed: " + utilityService.getExceptionMessage(ex));
                    })
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Saving failed: " + utilityService.getExceptionMessage(err));
            })


    }

    function cancel() {
        if (confirm('Are you sure to Cancel?') === true) {
            vm.showAssign = false;
            vm.isComment = false;
            vm.isStatusHistory = false;
            vm.commentText = '';
            vm.commentFileName = '';
            vm.noticeCommentFiles = '';
        }
    }

    function comment(taxNoticeDocumentId: any, fileName: any) {
        utilityService.showLoading();
        vm.isComment = true;
        vm.taxNoticeDocumentId = taxNoticeDocumentId;
        vm.fileName = fileName;

        taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
            .then(function (result) {
                vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
            })
    }

    function saveComment() {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((identity) => {
                vm.userName = identity.UserName;
                taxNoticeService.saveComment({
                    TaxNoticeDocumentId: vm.taxNoticeDocumentId,
                    UserName: identity.UserName,
                    Text: vm.commentText,
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember',
                    Files: vm.noticeCommentFiles
                })
                    .then(function (isSaved) {
                        if (isSaved === true) {
                            taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
                                .then(function (comments) {
                                    vm.commentText = null;
                                    vm.commentFileName = null;
                                    vm.noticeCommentFiles = undefined;
                                    vm.allComments[0] = comments;
                                    utilityService.hideLoading();
                                })
                                .catch((err) => {
                                    utilityService.hideLoading();
                                    alert("Saving failed: " + utilityService.getExceptionMessage(err));
                                })
                        } else {
                            utilityService.hideLoading();
                            alert("Saving failed: ");
                        }
                        return isSaved;
                    })
                    .catch(function (ex) {
                        console.error(ex);
                        utilityService.hideLoading();
                        alert("Saving failed: " + utilityService.getExceptionMessage(ex));
                    })
                return identity;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Saving failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function download(taxNoticeDocumentId: any) {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.downloadDocument({
                    TaxNoticeDocumentId: taxNoticeDocumentId,
                    UserName: result.UserName,
                    Text: 'downloading file',
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember'
                })
                    .then(function (result) {
                        if (result === true) {
                            utilityService.hideLoading();
                            return result;
                        }
                    })
                    .catch(function (ex) {
                        console.error(ex);
                        utilityService.hideLoading();
                        alert("Download failed: " + utilityService.getExceptionMessage(ex));
                    })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Download failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function onChangeFilters() {
        vm.filterDocs = vm.documentsbk;
        if (vm.filters.clientName) {
            vm.filterDocs = vm.filterDocs.filter(x => x.CompanyName.toLowerCase()
                .includes(vm.filters.clientName.toLowerCase()));
        }
        if (vm.filters.owner) {
            vm.filterDocs = vm.filterDocs.filter(x => x.OwnerName.toLowerCase()
                .includes(vm.filters.owner.toLowerCase()));
        }
        if (vm.filters.noticeNumber) {
            vm.filterDocs = vm.filterDocs.filter(x => String(x.RequestNumber) === String(vm.filters.noticeNumber));
        }
        if (vm.filters.uploadFrom) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) >= vm.filters.uploadFrom);
        }
        if (vm.filters.uploadTo) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) <= vm.filters.uploadTo);
        }
        vm.documents = vm.filterDocs;
        console.log(vm.filterDocs);
    }

    function complete(noticeDocumentId: any) {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.completeDocument(noticeDocumentId)
                    .then(function (isComplete) {
                        utilityService.hideLoading();
                        if (isComplete === true) {
                            taxNoticeUpdateService.refreshProcessTaxNotice('update');
                        }
                    })
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert(utilityService.getExceptionMessage(err));
            })
    }

    function decline(noticeDocumentId: any) {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.declineDocument(noticeDocumentId)
                    .then(function (isDecline) {
                        utilityService.hideLoading();
                        if (isDecline === true) {
                            taxNoticeUpdateService.refreshProcessTaxNotice('update');
                            return isDecline;
                        }
                    })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Download failed: " + utilityService.getExceptionMessage(err));
            })
    }
}
